export const Language = {
  PL: 'pl-PL',
  EN: 'en-US',
};

export const localStorageLanguageKey = 'i18nextLang';

export const defaultLanguage = Language.PL;
